import React, { useRef } from 'react'
import { getFormattedDate } from '../../functions/time';
import { CSVLink } from "react-csv";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import ButtonPrimary from "../../components/button/ButtonPrimary";
import InputText from "../../components/input/InputText";
import Inputselect from '../../components/input/InputSelect';

const Header = (props) => {
    const { users, searchTerm, handleSearch, setPagination } = props;
    const csvLinkRef = useRef();

    const handleExport = () => {
    csvLinkRef.current.link.click();
    };

    const headers = [
      { label: "Username", key: "userName" },
      { label: "Email", key: "email" },
      { label: "Date Joined", key: "registerationDate" },
      { label: "Last Login", key: "lastLoginTime" },
      { label: "Email confirmed", key: "emailConfirmed" },
    ];

    const options = [25, 50, 75, 100]

    const data = users.map((user) => ({
      userName: user.userName,
      email: user.email,
      registerationDate: getFormattedDate(user.registerationDate),
      lastLoginTime: getFormattedDate(user.lastLoginTime),
      emailConfirmed: user.emailConfirmed,
    }));

  return (
    <>
      <div className="flex">
        <h1>User Management</h1>
        <ButtonPrimary
          text="Export"
          iconLeft={<FileDownloadIcon />}
          onClick={handleExport}
        />
      </div>
      <div className="search-container">
        <InputText
          type="text"
          placeholder="Search by username"
          value={searchTerm}
          onChange={(event) => handleSearch(event.target.value)}
        />
        <ButtonPrimary className="mr-1" type="submit" text="search" />
        <div className="input-select">
          <select
            onChange={(e) =>
              setPagination((prev) => ({ ...prev, usersPerPage: e.target.value }))
            }
          >
            <option value="" disabled selected hidden>
              Users
            </option>{" "}
            {options.map((item, i) => (
              <option key={i} value={JSON.stringify(item)}>
                {item}
              </option>
            ))}
          </select>
        </div>{" "}
      </div>
      <CSVLink
        data={data}
        filename="users.csv"
        className="hidden"
        ref={csvLinkRef}
        target="_blank"
        headers={headers}
      />
    </>
  );
}

export default Header